/** Returns `value`, or throws `Expected <what>` when it is null or undefined. */
export const required = <T>(value: T | null | undefined, what: string): NonNullable<T> => {
  if (value == null) throw new Error(`Expected ${what}`)
  return value
}
